import BaseMask from "./_base.mask";

const CNAE_MASK = "9999-9/99";

const validateCnae = (cnae = "") => {
  const exp = /\.|-|\//g;
  cnae = cnae.toString().replace(exp, "");
  return cnae.length === 7;
};

export class CnaeMask extends BaseMask {
  static getType() {
    return "cnae";
  }

  getValue(value, settings) {
    return this.getVMasker().toPattern(value, CNAE_MASK);
  }

  getRawValue(maskedValue, settings) {
    return super.removeNotNumbers(maskedValue);
  }

  validate(value, settings) {
    return validateCnae(value);
  }
}
